// client/src/routes/portal/building.tsx — the portal's „Clădire" tab (SCR-PORT-007) · D-3368.
//
// The portal's half of BR-BLD-08: the same `MyBuildingSection` the console's „Clădirea mea" mounts
// (D-1730's rule). The tab is shown only to a person who lives in a clădire
// (`session.residentBuildingCount > 0`, `portal-nav.ts`); the layout guard admits the account whose
// only memberships are clădiri and lands it here (D-3372).
//
// `validateSearch` keeps `?ticket=` for the notification links of lanes 3 and 4; `?contract=` is the
// portal layout's own and is merged in by the router.

import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { MyBuildingSection } from '@/features/buildings/my/MyBuildingSection';
import { myBuildingSearchSchema } from '@/features/buildings/my/search';

export const Route = createFileRoute('/portal/building')({
  validateSearch: myBuildingSearchSchema,
  component: PortalBuildingScreen,
});

function PortalBuildingScreen() {
  const { t } = useTranslation();

  return <MyBuildingSection title={t('buildings.my.portalTitle')} />;
}
